/**
 * Enum representing various application roles.
 * Each role is associated with a unique numeric identifier.
 */
export enum ApplicationRole {
    RFCAdmin = 1,
    JVAdvisor = 2,
    DeptRepresentative = 3,
    Sponsor = 4,
    DeptViewer = 5,
    PartnerGeneralUser = 6,
    PartnerPowerUser = 7
}
export const ApplicationRoleMapping: Record<ApplicationRole, string> = {
    [ApplicationRole.RFCAdmin]: "RFCAdmin",
    [ApplicationRole.JVAdvisor]: "JVAdvisor",
    [ApplicationRole.DeptRepresentative]: "DeptRepresentative",
    [ApplicationRole.Sponsor]: "Sponsor",
    [ApplicationRole.DeptViewer]: "DeptViewer",
    [ApplicationRole.PartnerGeneralUser]: "PartnerGeneralUser",
    [ApplicationRole.PartnerPowerUser]: "PartnerPowerUser"
};